import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './i18n/LanguageContext';
import reportWebVitals from './reportWebVitals';

const urlParams = new URLSearchParams(window.location.search);

// Redirect /ws to WhatsApp
const pathname = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');
if (pathname === 'ws') {
  window.location.href = 'https://api.whatsapp.com/send/?phone=%2B601163688943';
}

// Support clean path-based routes like /download and /delete-account
const PATH_ROUTES = ['download', 'delete-account'];
const page = PATH_ROUTES.includes(pathname) ? pathname : (urlParams.get('page') || null);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App initialPage={page} />
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();
